var React = require('react');

function Uw (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.3699 19.68C22.3699 22.208 21.8235 24.24 20.7307 25.776C19.6701 27.312 18.3202 28.4 16.681 29.04C15.0418 29.68 13.3223 30 11.5224 30C8.17979 30 5.41569 29.216 3.23013 27.648C1.07671 26.08 0 23.424 0 19.68V0H6.07458V19.68C6.07458 22.24 6.6049 24.112 7.66554 25.296C8.72618 26.448 10.1404 27.024 11.9081 27.024C13.9008 27.024 15.54 26.432 16.8256 25.248C18.1434 24.064 18.8023 22.208 18.8023 19.68V0H22.3699V19.68Z","fill":"#35323E","key":0}),React.createElement("path",{"d":"M55 0L48.7326 29.424H43.333L37.4512 6.672L31.5213 29.424H25.736L19.4685 0H25.5431L30.0267 22.176L35.7156 0H41.3081L46.9006 22.224L51.3842 0H55Z","fill":"#35323E","key":1})]);
}

Uw.defaultProps = {"width":"55","height":"30","viewBox":"0 0 55 30","fill":"none"};

module.exports = Uw;

Uw.default = Uw;
